export default __webpack_public_path__ + "static/media/IMPORT_DATA_CREDIT_RECEIVER.1e353511.xlsx";